import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#0A1628] text-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16">
        {/* Top Section */}
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-12 pb-12 border-b border-white/10">
          <div>
            <h3 className="text-2xl font-bold text-white">Bursa Sulama Sistemleri</h3>
          </div>
          <p className="text-gray-400 text-lg">
            Bursa'nın Güvenilir Sulama Çözümleri
          </p>
        </div>

        {/* Links Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Kurumsal */}
          <div>
            <h3 className="text-xl font-bold mb-4">Kurumsal</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/hakkimizda"
                  className="text-gray-400 hover:text-[#14B8A6] transition-colors"
                >
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link
                  to="/hizmetler"
                  className="text-gray-400 hover:text-[#14B8A6] transition-colors"
                >
                  Hizmetlerimiz
                </Link>
              </li>
              <li>
                <Link
                  to="/iletisim"
                  className="text-gray-400 hover:text-[#14B8A6] transition-colors"
                >
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* Hizmetler */}
          <div>
            <h3 className="text-xl font-bold mb-4">Hizmetler</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/hizmetler"
                  className="text-gray-400 hover:text-[#14B8A6] transition-colors"
                >
                  Sprey Sprink Sistemleri
                </Link>
              </li>
              <li>
                <Link
                  to="/hizmetler"
                  className="text-gray-400 hover:text-[#14B8A6] transition-colors"
                >
                  Yağmurlama Sistemleri
                </Link>
              </li>
              <li>
                <Link
                  to="/hizmetler"
                  className="text-gray-400 hover:text-[#14B8A6] transition-colors"
                >
                  Damlama Sistemleri
                </Link>
              </li>
              <li>
                <Link
                  to="/hizmetler"
                  className="text-gray-400 hover:text-[#14B8A6] transition-colors"
                >
                  Tamir & Tadilat
                </Link>
              </li>
            </ul>
          </div>

          {/* Bilgi */}
          <div>
            <h3 className="text-xl font-bold mb-4">Bilgi</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/kvkk"
                  className="text-gray-400 hover:text-[#14B8A6] transition-colors"
                >
                  KVKK
                </Link>
              </li>
              <li>
                <Link
                  to="/kvkk"
                  className="text-gray-400 hover:text-[#14B8A6] transition-colors"
                >
                  Çerez Politikası
                </Link>
              </li>
            </ul>
          </div>

          {/* İletişim */}
          <div className="text-right">
            <div className="mb-6">
              <p className="text-2xl font-serif mb-2">© 2025</p>
              <p className="text-xl font-bold">Bursa Sulama</p>
              <p className="text-sm text-gray-400 mt-1">
                Tüm hakları saklıdır
              </p>
            </div>
            <a
              href="https://wa.me/905071344668?text=Merhaba,%20ben%20sizinle%20bursasulamasistemleri.com%20sitesinden%20iletişime%20geçiyorum."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#25D366] hover:text-[#1DA851] transition-colors whitespace-nowrap"
            >
              <i className="ri-whatsapp-fill text-2xl"></i>
              <span className="font-medium">WhatsApp İletişim</span>
            </a>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
            <div className="flex-1">
              <div className="bg-white/5 rounded-2xl p-6 backdrop-blur-sm">
                <img
                  src="https://public.readdy.ai/ai/img_res/a28e79822a2e8637b78ad841c0adcf63.jpg"
                  alt="Sulama Sistemleri"
                  className="w-full h-48 object-cover rounded-xl"
                />
              </div>
            </div>
            <div className="flex-1 text-center lg:text-left px-6">
              <h4 className="text-3xl lg:text-4xl font-serif leading-tight">
                Profesyonel
                <br />
                Sulama Çözümleri
                <br />
                Bursa'da
              </h4>
            </div>
            <div className="flex-1 text-center lg:text-right">
              <p className="text-gray-400 mb-4">
                Hemen iletişime geçin,
                <br />
                ücretsiz keşif hizmeti alın
              </p>
              <a
                href="https://wa.me/905071344668?text=Merhaba,%20ben%20sizinle%20bursasulamasistemleri.com%20sitesinden%20iletişime%20geçiyorum."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1DA851] text-white px-8 py-4 rounded-full transition-all duration-300 hover:scale-105 whitespace-nowrap"
              >
                <span className="font-semibold">WhatsApp'tan Ulaş</span>
                <i className="ri-arrow-right-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-white/10 text-center text-gray-500 text-sm">
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#14B8A6] transition-colors"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
